













































import Vue from 'vue'
import Component from 'vue-class-component'
import Modal from '@/components/Modal.vue'
import Input from '@/components/inputs/Input.vue'
import Checkbox from '@/components/inputsV2/Checkbox.vue'
import { FacilityModule } from '@/store/modules/facility.module'
import { getModule } from 'vuex-module-decorators'
import { IFacility, IPayerType } from '@zunta/configurations'
import { template } from '@babel/core'

@Component({
  components: { Checkbox, Input, Modal },
  props: {
    selectedTemplate: {
      type: Object
    },
    payerTypes: {
      type: Array
    }
  }
})
export default class ConditionsModal extends Vue {
  timeframe: number | null = null
  selectedPayerTypes: number[] = []
  facilityModuleInstance: FacilityModule = getModule(FacilityModule, this.$store)

  get isAllPayersSelected () {
    return this.$props.payerTypes.length === this.selectedPayerTypes.length
  }

  isPayerSelected (payer: IPayerType) {
    // @ts-ignore
    return this.selectedPayerTypes.includes(payer.id)
  }

  toggleAllPayerTypes () {
    this.selectedPayerTypes = !this.isAllPayersSelected
        ? this.$props.payerTypes.map((payer: IPayerType) => payer.id)
        : this.selectedPayerTypes = []
  }

  togglePayerType (payerType: number) {
    const payerTypeIndex = this.selectedPayerTypes.findIndex((item: number) => item === payerType)
    if (payerTypeIndex !== -1) {
      this.selectedPayerTypes.splice(payerTypeIndex, 1)
      return
    }
    this.selectedPayerTypes.push(payerType)
  }

  async mounted () {
    this.selectedPayerTypes = !this.$props.selectedTemplate.payers || !this.$props.selectedTemplate.payers.length
        ? this.selectedPayerTypes = this.$props.payerTypes.map((payer: IPayerType) => payer.id)
        : this.$props.selectedTemplate.payers.map((item: any) => Number(item))

    if (this.$props.selectedTemplate.timeframe) {
      this.timeframe = this.$props.selectedTemplate.timeframe
    }
  }

  update () {
    const payload = {
      timeframe: this.timeframe ? Math.round(this.timeframe) : null,
      payers: this.isAllPayersSelected ? null : this.selectedPayerTypes
    }
    if (this.$props.selectedTemplate.type === 'MESSAGE') {
      this.$emit('update', {
        messageId: this.$props.selectedTemplate.id,
        payload
      })
    } else {
      this.$emit('update', {
        letterId: this.$props.selectedTemplate.id,
        payload
      })
    }
  }
}
